export default __webpack_public_path__ + "GothaProLig.otf";